import gql from "graphql-tag";

export const addLeadPicksMutationFragment = gql`
	fragment addLeadPicksMutationFragment on GenericPayload {
		success
	}
`;
